module.exports = __webpack_public_path__ + "img/1517662735.535ce58b.jpg";